import { Loc } from 'main.core';
import { NoticeBase } from 'b24network.vue.cross-scenario-shared-js';

/**
 * Invite link is broken or containing incorrect data
 */
export class WrongInviteToken extends NoticeBase
{
	constructor()
	{
		super(
			Loc.getMessage('EXT_B24NET_LOGGING_IN_ASK_NEW_INVITE', { '[br]': '<br>' }),
			Loc.getMessage('EXT_B24NET_LOGGING_IN_INVITE_LINK_IS_DEPRECATED'),
		);
	}
}
